import React, { useState, useEffect } from 'react';
import { useToast } from '../../contexts/ToastContext';
import { commercialManagerService } from '../../services/userService';
import { CommercialManager } from '../../types/User';
import './UserForm.css';

interface CommercialManagerFormProps {
  manager: CommercialManager | null;
  onSuccess: () => void;
  onCancel: () => void;
}

const CommercialManagerForm: React.FC<CommercialManagerFormProps> = ({ manager, onSuccess, onCancel }) => {
  const { showToast } = useToast();
  const [formData, setFormData] = useState<CommercialManager>({
    nombre: '',
    nif: '',
    email: '',
    telefono: '',
    departamento: '',
  });

  const departamentoOptions = ['Ventas', 'Fidelizacion', 'Partners'];
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (manager) {
      setFormData(manager);
    }
  }, [manager]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (manager?.id) {
        await commercialManagerService.update(manager.id, formData);
        showToast('Responsable comercial actualizado correctamente');
      } else {
        await commercialManagerService.create(formData);
        showToast('Responsable comercial creado correctamente');
      }
      onSuccess();
    } catch (err: any) {
      setError(err.response?.data?.message || 'Error al guardar el responsable comercial');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="user-form">
      <h3>{manager ? 'Editar Responsable Comercial' : 'Crear Responsable Comercial'}</h3>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group span-2">
            <label htmlFor="nombre">Nombre *</label>
            <input
              type="text"
              id="nombre"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
              maxLength={100}
            />
          </div>
          <div className="form-group">
            <label htmlFor="nif">NIF *</label>
            <input
              type="text"
              id="nif"
              name="nif"
              value={formData.nif}
              onChange={handleChange}
              required
              maxLength={20}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group span-2">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              maxLength={100}
            />
          </div>
          <div className="form-group">
            <label htmlFor="telefono">Teléfono</label>
            <input
              type="tel"
              id="telefono"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
              maxLength={20}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="departamento">Departamento</label>
            <select
              id="departamento"
              name="departamento"
              value={formData.departamento || ''}
              onChange={handleChange}
            >
              <option value="">Seleccionar...</option>
              {departamentoOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-actions">
          <button type="button" onClick={onCancel} className="btn-secondary" disabled={loading}>
            Cancelar
          </button>
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Guardando...' : manager ? 'Actualizar' : 'Crear'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CommercialManagerForm;
